import { all, takeEvery, put } from 'redux-saga/effects'
import { showErrorNotification } from '../notifications/actions'
import { SAVE_VIEW_ACCESS } from './actions'
import { requestedAccessSucceeded, requestAccess, saveViewAccess } from './slice'
import { ViewAccessAction } from './types'

/**
 * Store fresh view permissions into Redux.
 * No sessionStorage caching — page-level permissions are always fetched from API.
 */
export function* STORE_VIEW_ACCESS({ payload }: ViewAccessAction) {
  try {
    yield put(requestAccess())
    yield put(saveViewAccess(payload))
    yield put(requestedAccessSucceeded())
  } catch (error) {
    console.log(error)
    yield put(showErrorNotification('Something went wrong while fetching access'))
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(SAVE_VIEW_ACCESS, STORE_VIEW_ACCESS),
  ])
}
